<a class="avatar" (click)="openModal(content)">
   <!-- <app-icon [iconName]="'user'" [width]="28" [height]="28"></app-icon> -->
   <i class="fi fi-rr-user"></i>
</a>

<ng-template #content let-modal >
    
    <div class="p-3">
  
    <div *ngIf="!isPasswordOpen && !isInfoOpen && !isLanguagesOpen">
  
      <a class="drop-item" (click)="open('info')">
        <!-- <app-icon [iconName]="'user-edit'" [width]="30" [height]="30"></app-icon>  -->
        <i class="fi fi-rr-admin-alt"></i>
        {{'ACCAUNT' | translate}}
      </a>

      <a class="drop-item" (click)="open('languages')">
        <!-- <app-icon [iconName]="'language'" [width]="30" [height]="30"></app-icon>  -->
        <i class="fi fi-rr-language"></i>
        
        {{'LANGUAGES' | translate}}
      </a>
      <a class="drop-item" (click)="open('password')">
        <!-- <app-icon [iconName]="'lock'" [width]="25" [height]="25"></app-icon>  -->
        <i class="fi fi-rr-lock"></i>
        {{'PASSWORD' | translate}}
      </a>

      <app-change-themes></app-change-themes>
  
      <app-pwa-install></app-pwa-install>

      <a class="drop-item" (click)="logout($event)">
        <!-- <app-icon [iconName]="'logout'" [width]="30" [height]="30"></app-icon>  -->
        <i class="fi fi-rr-sign-out-alt"></i>
        {{'LOGOUT' | translate}}
      </a>
    </div>

    <ng-container *ngIf="isPasswordOpen || isInfoOpen || isLanguagesOpen">
      <a class="drop-item" (click)="closeAllSections($event)">
        <i class="fi fi-rr-left"></i> {{'BACK' | translate}}
      </a>
    </ng-container>

    <div class="scrollable-content">
      <app-change-password *ngIf="isPasswordOpen"></app-change-password>
      <app-change-my-info *ngIf="isInfoOpen"></app-change-my-info>
      <app-change-language (LangClose)="closeAllSections()" *ngIf="isLanguagesOpen"></app-change-language>
    </div>
  </div>
</ng-template>
